<div class="container col-sm-8 pt-5 webview text-center" [@flyInOut]="'in'">
  <h1 class="text-center font-weight-normal-calibre pb-4 questxt">
    {{ question }}
  </h1>
  <div class="container-fluid px-0 text-center">
    <div class="col-md-8 offset-md-2 px-0">
      <div class="col-md-12 mb-2 px-0" *ngIf="showMap">
        <agm-map
          [latitude]="lat"
          [longitude]="lng"
          [zoomControl]="false"
          [disableDoubleClickZoom]="true"
          [zoom]="18"
          [scrollwheel]="false"
          [streetViewControl]="false"
        >
          <agm-marker
            [latitude]="lat"
            [longitude]="lng"
            [iconUrl]="markerIconUrl()"
          ></agm-marker>
        </agm-map>
      </div>
      <div class="row mt-2">
        <div class="col-sm-8 pr-0">
          <input
            ngx-google-places-autocomplete
            [options]="options"
            #places="ngx-places"
            (ngModelChange)="setFlag()"
            (keydown.space)="pointer_name ? null : $event.preventDefault()"
            [disabled]="isDisabled"
            (onAddressChange)="handleAddressChange($event)"
            type="text"
            id="autocomplete"
            class="form-control autocomplete"
            placeholder="Search Business Name and Select"
            [(ngModel)]="pointer_name"
          />
          <!-- <div *ngIf="clicksCount === 3" class="boxcolour alertMsg text-right">
            <span class="fa fa-exclamation-circle mr-1" type="Icon"></span>You
            have one more attempt remaining
          </div> -->
        </div>
        <div class="col-sm-1 pl-2 mt-2">
          <i
            class="fa fa-pencil font20 curpntr"
            aria-hidden="true"
            (click)="edit()"
          ></i>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-sm-8 pr-0">
          <input
            name="pointer_name"
            id="autocomplete2"
            #pointer
            ngx-google-places-autocomplete
            class="form-control"
            (keydown.space)="formatedAddress ? null : $event.preventDefault()"
            (onAddressChange)="handleAddressChange2($event)"
            type="text"
            placeholder="Start Typing Street Address and Select"
            [(ngModel)]="formatedAddress"
            (ngModelChange)="ChangedAddress($event)"
          />

        

        </div>
        <div class="col-sm-2 pr-0">
          <button
          id="confirmBTN"
          class="btn disabledButton next mr-2 ml-2 mt-2 mb-2 font22 text-uppercase combtn" style="font-size: 14px !important;    padding: 0 !important;
          margin: 0 !important; width: 90px !important ; height: 37px !important;"
          (click)="ConfirmAddress()"
          [ngClass]="{ combtn: ConfirmDisable }"
        >
          Confirm
        </button>
        </div>
        <!-- <div class="col-sm-3">
          <input name="Suite" #Suite class="form-control" (keydown.space)="suite ? null : $event.preventDefault()"
            type="text" placeholder="Suite#" [(ngModel)]="suite" />
        </div> -->
      </div>
      <div class="row mt-3" *ngFor="let esiid of esiids; let i = index">
        
         
        <div class="col-sm-8 pr-0 commercial">
          <!-- <ng-select
          *ngIf="!singleEsiid && i == 0 && esiid.value != '' && esiidResponses.length != 0" 
          name="esiid"
          [items]="esiidResponses"
          placeholder="ESI ID"
          [searchable]="false"
          [clearable]="false"
          [(ngModel)]="esiid.text"
          id="{{ 'focusWeb0' }}"
          (change)="Changed(0,esiid.text)"
        ></ng-select>
   
        <input 
        *ngIf="i == 0 && esiidResponses.length == 0"
         name="esiid"
         class="form-control"
         id="{{ 'focusWeb' + i }}"
         (keydown.space)="esiid.value ? null : $event.preventDefault()"
         type="number"
         placeholder="ESI ID"
         [(ngModel)]="esiid.value"
       />
          <input 
          *ngIf="i != 0  &&  i >= esiidResponses.length"
            name="esiid"
            class="form-control"
            id="{{ 'focusWeb' + i }}"
            (keydown.space)="esiid.value ? null : $event.preventDefault()"
            type="number"
            placeholder="ESI ID"
            [(ngModel)]="esiid.value"
          />
          <ng-select
          *ngIf="i != 0 && esiidResponses.length != 0 && esiidResponses.length > 1 && i < esiidResponses.length"
          name="esiid"
          [items]="esiidResponses"
          placeholder="ESI ID"
          [searchable]="false"
          [clearable]="false"
          [(ngModel)]="esiid.text"
          id="{{ 'focusWeb' + i }}"
          (change)="Changed(i,esiid.text)"
        ></ng-select> -->
        <input 
            [typeaheadMinLength]="0"  [typeaheadOptionsLimit]="esiidResponses.length" [typeaheadScrollable] = "true"
            [typeahead]="esiidResponses" 
            name="esiid"
            class="form-control"
            id="{{ 'focusWeb' + i }}"
            (keydown.space)="esiid.value ? null : $event.preventDefault()"
            (ngModelChange)="EditESIID(i,esiid.value)"
            placeholder="ESI ID"
            [(ngModel)]="esiid.value"
          />
          <div  id="{{ 'ErrorMsg' + i }}" class="boxcolour alertMsg text-right">
            
          </div>
        </div>
        

        <div class="col-sm-1 pl-2 mt-2" *ngIf="esiids.length > 1">
          <i
            class="fa fa-times font20 curpntr"
            aria-hidden="true"
            (click)="remove(i)"
          ></i>
        </div>
      </div>
      <div class="row mt-3">
        <!-- <label class="pl-3" for="home_address font-weight-semibold-calibre"
          ><a
            href="https://utilitychoice.com/tools/esiid_lookup"
            style="color: #05f !important; font-family: 'Calibre-SemiBold'"
            target="_blank"
            >Click here
          </a>
          <span
            style="color: #484246 !important; font-family: 'Calibre-SemiBold'"
            >to search for your ESI ID</span
          ></label -->
        
        <div class="col-sm-12">
          <button
            class="btn btn-black-ooutline mr-2 pull-left font16 text-uppercase"
            (click)="AddEsiid()"
          >
            ADD ESI ID
          </button>
        </div>
      </div>
      <br />
    </div>
    <div class="row">
      <div class="col-sm-12">
        <button
          class="btn next mr-2 ml-2 disabledButton mt-2 mb-2 font22 text-uppercase"
          [ngClass]="{ combtn: isAddressSelected }"
          (click)="next()"
        >
          Next
        </button>
      </div>
    </div>
    <div class="row mt-2" *ngIf="showTip">
      <div
        class="m-auto col-sm-10 col-md-6 col-xl-5 blockbg boxclr text-center"
      >
        <img src="assets/images/flash.png" class="mb-1" />
        <p class="text-center tiphead">JUST AN FYI</p>
        <p class="text-center tipmes">{{ questionObj.tip1 }}</p>
      </div>
    </div>
  </div>
</div>

<div
  class="container mobileview px-0 pt-3"
  [attr.id]="questionObj._id"
  style="float: left"
>
  <div class="d-flex h-100 row col-sm-12 pr-0">
    <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
      <img style="width: 100%" src="assets/images/logo-charcoal.png" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box">
        <h1 class="questionMob text-left">{{ question }}</h1>
      </div>
    </div>
  </div>
  <div class="m-auto">
    <div class="container mt-2">
      <div class="col-12 mb-2 px-0 pull-right" *ngIf="showMap">
        <agm-map
          [latitude]="lat"
          [longitude]="lng"
          [zoomControl]="false"
          [disableDoubleClickZoom]="true"
          [zoom]="18"
          [scrollwheel]="false"
          [streetViewControl]="false"
        >
          <agm-marker
            [latitude]="lat"
            [longitude]="lng"
            [iconUrl]="markerIconUrl()"
          ></agm-marker>
        </agm-map>
      </div>
    </div>
    <div class="col-10 d-flex pull-right pl-4">
      <div class="col-11 px-0">
        <input
          ngx-google-places-autocomplete
          [options]="options"
          #places="ngx-places"
          (ngModelChange)="setFlag()"
          (keydown.space)="pointer_name ? null : $event.preventDefault()"
          [disabled]="isDisabled"
          (onAddressChange)="handleAddressChange($event)"
          type="text"
          id="autocomplete"
          class="form-control autocomplete"
          placeholder="Search Business Name and Select"
          [(ngModel)]="pointer_name"
        />
        <!-- <div *ngIf="clicksCount === 3" class="boxcolour alertMsg text-right">
          <span class="fa fa-exclamation-circle mr-1" type="Icon"></span>You
          have one more attempt remaining
        </div> -->
      </div>
      <div class="col-1 pl-2 mt-1">
        <i class="fa fa-pencil" aria-hidden="true" (click)="edit()"></i>
      </div>
    </div>
    <div class="col-10 m-auto px-0 pull-right d-flex">
      <div class="col-11 pl-4 mt-3">
        <input
          name="pointer_name"
          id="autocomplete2"
          #pointer
          ngx-google-places-autocomplete
          class="form-control"
          (keydown.space)="formatedAddress ? null : $event.preventDefault()"
          type="text"
          placeholder="Start Typing Street Address and Select"
          [(ngModel)]="formatedAddress"
          (onAddressChange)="handleAddressChange2($event)"
          (ngModelChange)="ChangedAddress($event)"
        />
      </div>
       
      <!-- <div class="col-3 pl-0">
        <input name="Suite" #Suite_mob class="form-control" (keydown.space)="suite ? null : $event.preventDefault()"
          type="text" placeholder="Suite#" [(ngModel)]="suite" />
      </div> -->
    </div>
     <div class="col-10 m-auto px-0 pull-right d-flex">
      <div class="col-10 pl-4 mt-3">
      <button   
      id="confirmBTN"
      class="btn disabledButton next mr-2 ml-2 mt-2 mb-2 font22 text-uppercase combtn" style="font-size: 14px !important;    padding: 0 !important;
      margin: 0 !important; width: 90px !important ; height: 37px !important;"
      (click)="ConfirmAddress()"
      [ngClass]="{ combtn: ConfirmDisable }"
    >
      Confirm
    </button>
    </div>
    </div>
    <div
      class="col-10 mt-2 pull-right mr-2 ml-2 pl-4"
      *ngIf="showMap && isAddressSelected && esiidResponses.length == 0"
    >
      <div class="col-12 custom-control custom-checkbox chkbox mb-2 ml-2">
        <input
          type="checkbox"
          style="display: inline-block"
          class="custom-control-input mgntp10"
          id="confirm"
          value="isChecked"
          name="is_confirm"
          [(ngModel)]="isChecked"
          (ngModelChange)="confirm()"
          
        />
        <label
          style="display: inline-block"
          class="custom-control-label font16"
          for="confirm"
          >Please confirm info above is correct
        </label>
      </div>
    </div>
    <div id="tooltip" class="col-12 mt-2 mb-4" style="float: left;visibility: hidden;" >
      <div
        class="m-auto col-sm-10 col-md-6 col-xl-6 blockbg boxclr text-center"
      >
        <img src="assets/images/flash.png" class="mb-1" />
        <p class="text-center tiphead">JUST A HEADS UP</p>
        <p class="text-center tipmes">{{ questionObj.tip2 }}</p>
      </div>
    </div>
    <div class="container">
      <div
        class="col-10 pull-right pr-0"
        style="width: 100% !important; text-align: right"
      >
        <div *ngIf="isChecked" class="ash_box text-right mb-4">
          <h1 class="ansMob text-right">Yes</h1>
        </div>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>
  <div id="remember" style="float: left">
    <div *ngIf="isChecked && isAddressSelected && pointer_name != ''">
      <div class="d-flex h-100 row col-sm-12 pr-0 mt-3">
        <div
          class="justify-content-center align-self-center col-sm-3 col-3 pl-0"
        >
          <img style="width: 100%" src="assets/images/logo-charcoal.png" />
        </div>
        <div class="col-sm-9 col-9 px-0 my-auto">
          <div class="arrow_box">
            <h1 class="questionMob text-left">
              {{ questionObj.remember_question }}
            </h1>
          </div>
        </div>
      </div>
      <div class="col-10 pull-right">
        <div class="col-12 d-flex mt-2">
          <div class="col-6 pl-0 box-shadow-none">
            <label
              class="card card-list card-small text-center d-inline-block w-100 font16"
              id="yes_mob"
              (click)="getAcceptance('Yes')"
              >Yes</label
            >
          </div>
          <div class="col-6 pr-0 box-shadow-none">
            <label
              class="card card-list card-small text-center d-inline-block w-100 font16"
              id="no_mob"
              (click)="getAcceptance('No')"
              >No</label
            >
          </div>
        </div>
        <div class="mb-2" style="width: 100% !important; float: left">
          <div *ngIf="no_worries" class="ash_box mt-2 pull-right">
            <h1 class="ansMob text-left">{{ yes_no }}</h1>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <div id="no" class="mb-2 mt-3" style="float: left">
        <div class="d-flex h-100 row col-sm-12 pr-0 mt-3" *ngIf="show_no">
          <div
            class="justify-content-center align-self-center col-sm-3 col-3 pl-0"
          >
            <img style="width: 100%" src="assets/images/logo-charcoal.png" />
          </div>
          <div class="col-sm-9 col-9 px-0 my-auto mt-4">
            <div class="arrow_box">
              <h1 class="questionMob text-left">
                {{ questionObj.exit_question }}
              </h1>
            </div>
          </div>
        </div>
        <div class="col-12 px-0 m-auto" *ngIf="show_no">
          <div class="col-9 pl-0 pull-right">
            <label
              class="custom-control custom-checkbox chkbox mb-2"
              style="float: left"
            >
              <input
                type="checkbox"
                style="display: inline-block"
                class="custom-control-input mgntp10"
                id="exit"
                value="isExit"
                name="in_contract"
                [(ngModel)]="isExit"
                (ngModelChange)="getNext()"
              />
              <label
                style="display: inline-block"
                class="custom-control-label font16"
                for="exit"
              >
                Okay
              </label>
            </label>
          </div>
          <div class="col-12" style="width: 100% !important; float: left">
            <div *ngIf="isExit" class="ash_box text-right pull-right">
              <h1 class="ansMob text-left">
                I understand, thank you. Let’s carry on
              </h1>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <div id="yes">
        <div *ngIf="show_yes">
          <div
            *ngFor="let esiid of esiids; let i = index"
            class="col-12 px-0"
            style="float: left"
          >
            <div class="d-flex h-100 row col-sm-12 pr-0" id="{{ i }}">
              <div
                class="justify-content-center align-self-center col-sm-3 col-3 pl-0"
              >
                <img
                  style="width: 100%"
                  src="assets/images/logo-charcoal.png"
                />
              </div>
              <div class="col-sm-9 col-9 px-0 my-auto">
                <div class="arrow_box">
                  <h1
                    class="questionMob text-left mb-0"
                    *ngIf="i === 0 || i > 1"
                  >
                    {{ questionObj.esiid_q1 }}
                  </h1>
                  <h1 class="questionMob text-left" *ngIf="i === 0">
                    Need help finding it?
                    <!-- <a
                      href="https://utilitychoice.com/tools/esiid_lookup"
                      style="color: #05f !important;font-family: Calibre-Regular' !important;"
                      target="_blank"
                      >Click here
                    </a> -->
                  </h1>
                  <h1 class="questionMob text-left" *ngIf="i !== 0">
                    {{ questionObj.esiid_q2 }}
                  </h1>
                </div>
              </div>
            </div>
            <div class="col-sm-12 m-auto">
              <div class="col-10 d-flex pull-right px-0 mb-2">
                <div class="col-9 pr-0 commercial">
                  <!--<input
                    name="esiid"
                    class="form-control"
                    id="{{ 'focus' + i }}"
                    (keydown.space)="
                      esiid.value ? null : $event.preventDefault()
                    "
                    type="number"
                    placeholder="ESI ID"
                    [(ngModel)]="esiid.value"
                    (keyup.enter)="showAddEsiid()"
                  />-->

                     <!-- <ng-select
                      *ngIf="!singleEsiid && i == 0 && esiid.value != '' && esiidResponses.length != 0" 
                      name="esiid"
                      [items]="esiidResponses"
                      placeholder="ESI ID"
                      [searchable]="false"
                      [clearable]="false"
                      [(ngModel)]="esiid.text"
                      id="{{ 'focus0' }}"
                      (change)="Changed(0,esiid.text)"
                    ></ng-select>

                    <input 
                    *ngIf="i == 0 && esiidResponses.length == 0"
                     name="esiid"
                     class="form-control"
                     id="{{ 'focus' + i }}"
                     (keydown.space)="esiid.value ? null : $event.preventDefault()"
                     type="number"
                     placeholder="ESI ID"
                     [(ngModel)]="esiid.value"
                     (keyup.enter)="showAddEsiid()"
                   />
                     <input 
                      *ngIf="i != 0  &&  i >= esiidResponses.length"
                        name="esiid"
                        class="form-control"
                        id="{{ 'focus' + i }}"
                        (keydown.space)="esiid.value ? null : $event.preventDefault()"
                        type="number"
                        placeholder="ESI ID"
                        [(ngModel)]="esiid.value"
                       (keyup.enter)="showAddEsiid()"
                      />
                      <ng-select
                      *ngIf="i != 0 && esiidResponses.length != 0 && esiidResponses.length > 1 && i < esiidResponses.length"
                      name="esiid"
                      [items]="esiidResponses"
                      placeholder="ESI ID"
                      [searchable]="false"
                      [clearable]="false"
                      [(ngModel)]="esiid.text"
                      id="{{ 'focus' + i }}"
                      (change)="Changed(i,esiid.text)"
                    ></ng-select> -->
                    <input
                    [typeaheadMinLength]="0"  [typeaheadOptionsLimit]="esiidResponses.length" [typeaheadScrollable] = "true"
                    [typeahead]="esiidResponses" 
                    name="esiid"
                    class="form-control"
                    id="{{ 'focus' + i }}"
                    (keydown.space)="
                      esiid.value ? null : $event.preventDefault()
                    "
                    (ngModelChange)="EditESIID(i,esiid.value)"
                    placeholder="ESI ID"
                    [(ngModel)]="esiid.value"
                    (keyup.enter)="showAddEsiid()"
                    type="number"  pattern="\d*"
                  />
                  <div  id="{{ 'ErrorMsgMob' + i }}" class="boxcolour alertMsg text-right">
            
                  </div>
                  
                </div>
                <div class="col-1 pl-0 mt-1 ml-2" *ngIf="esiids.length > 1">
                  <i
                    class="fa fa-times"
                    aria-hidden="true"
                    (click)="remove(i)"
                  ></i>
                </div>
              </div>
            </div>
            <div
              class="col-12 mb-4"
              style="width: 100% !important; float: left"
            >
              <div *ngIf="esiid.value" class="mb-3 ash_box pull-right">
                <h1 class="ansMob text-left">
                  ESI ID #{{ i + 1 }}: {{ esiid.value }}
                </h1>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
      <div id="add_id" class="mb-4" style="float: left">
        <div class="d-flex h-100 row col-sm-12 pr-0" *ngIf="addESIID">
          <div
            class="justify-content-center align-self-center col-sm-3 col-3 pl-0"
          >
            <img style="width: 100%" src="assets/images/logo-charcoal.png" />
          </div>
          <div class="col-sm-9 col-9 px-0 my-auto">
            <div class="arrow_box">
              <h1 class="questionMob text-left">{{ questionObj.add_esiid }}</h1>
            </div>
          </div>
        </div>
        <div class="col-10 pull-right" *ngIf="addESIID">
          <div class="col-12 d-flex mt-2">
            <div class="col-6 pl-0 box-shadow-none">
              <label
                class="card card-list card-small text-center d-inline-block w-100 font16"
                id="esiid_yes_mob"
                (click)="otherESIID('Yes')"
                >Yes</label
              >
            </div>
            <div class="col-6 pr-0 box-shadow-none">
              <label
                class="card card-list card-small text-center d-inline-block w-100 font16"
                id="esiid_no_mob"
                (click)="otherESIID('No')"
                >No</label
              >
            </div>
          </div>
        </div>
      </div>
      <div id="typing">
        <div class="d-flex h-100 row col-sm-12 pr-0" *ngIf="showTyping">
          <div
            class="justify-content-center align-self-center col-sm-3 col-3 pl-0"
          >
            <img style="width: 100%" src="assets/images/logo-charcoal.png" />
          </div>
          <div class="col-sm-2 col-2 px-0 my-auto">
            <div class="arrow_box">
              <img
                class="p-2 pl-2 ml-1"
                src="assets/images/typing-animated-gif-4.gif"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #template>
  <div class="modal-header py-0">
    <div class="col-12 text-right py-0 px-0">
      <button
        type="button"
        class="close pull-right borderNone closeModelAlign"
        aria-label="Close"
        (click)="modalRef.hide()"
      >
        <div _ngcontent-c5="" class="float-right mr-1 mt-1">
          <img src="assets/images/editchart-close.svg" width="17" />
        </div>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <h4 class="utility-modal-title font20 text-center text-uppercase">
      Multiple Utilities in {{ zipcode }}
    </h4>
    <p class="utility-sub-title font20 text-center">
      Please select your utility from the list below:
    </p>
    <div class="col-sm-12 mb-2" *ngFor="let utility of utilities">
      <div class="d-flex m-auto col-sm-12 col-md-12 col-xl-6">
        <div class="modal-cards w-100">
          <div
            class="card card-list pt-2 text-center"
            id="{{ utility.Utility }}"
            (click)="selectUtility(utility.Utility)"
          >
            <div class="d-flex m-auto col-sm-12 col-md-12 col-xl-6">
              <img src="{{ utility.src }}" height="50" />
            </div>
            <label
              class="utility-sub-title font16"
              for="{{ utility.Utility }}"
              >{{ utility.Utility }}</label
            >
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="col-12 text-center">
      <p class="utility-sub-title font15" *ngIf="isAddressSelected">
        Thank you! Your utility selection is saved.
      </p>
      <button
        class="btn mr-2 ml-2 col-12 font-weight-bold-calibre contbtn text-uppercase"
        (click)="closeModalWithOutContact()"
      >
        Next
      </button>
    </div>
  </div>
</ng-template>
<ng-template #noservice>
  <div class="modal-header py-0 px-1 pt-1">
    <div class="col-12 text-right py-0 px-0">
      <button
        type="button"
        class="close pull-right borderNone closeModelAlign"
        aria-label="Close"
        (click)="modalRef.hide()"
      >
        <div _ngcontent-c5="" class="float-right mr-1 mt-1">
          <img src="assets/images/editchart-close.svg" width="17" />
        </div>
      </button>
    </div>
  </div>
  <div class="modal-body pt-0">
    <h4
      class="utility-modal-title font20 text-center text-uppercase"
      *ngIf="zipcode"
    >
      SERVICE IS UNAVAILABLE FOR {{ zipcode }}
    </h4>
    <h4
      class="utility-modal-title font20 text-center text-uppercase"
      *ngIf="!zipcode"
    >
      SERVICE IS UNAVAILABLE
    </h4>
    <p class="utility-sub-title font20">
      If it were up to us, we’d love to have you as our newest customer! We’re
      sorry that we don’t have a say in which areas are open to energy choice.
    </p>
    <p class="utility-sub-title font20">
      Check back with us in the future, we’d love to stay connected with you!
    </p>
    <p class="utility-sub-title font20">
      In the meantime, iIf you have a question, drop us a line and let us know
      how we can be of service.
    </p>
    <div class="col-12 text-center">
      <button
        class="btn mr-2 ml-2 col-12 font-weight-bold-calibre contbtn text-uppercase"
        (click)="closeModal()"
      >
        HELP
      </button>
    </div>
    <p class="utility-sub-title font20 text-center">
      Who do you know that would like to help make this world a better, brighter
      place while finding a deal on energy? Please let them know about us!
    </p>
    <div class="sidebar-ftr">
      <ul class="list-inline mb-2">
        <li>
          <a
            href="https://www.facebook.com/honestgorilla1/"
            class="px-0"
            target="_blank"
            ><img src="assets/images/facebook-co.svg" width="48px"
          /></a>
        </li>
        <li>
          <a
            href="https://twitter.com/honestgorilla"
            class="px-0"
            target="_blank"
            ><img src="assets/images/twitter-co.svg" width="48px"
          /></a>
        </li>
        <li>
          <a
            href="https://www.instagram.com/honestgorilla_energy/ "
            class="px-0"
            target="_blank"
            ><img src="assets/images/instragram-co.svg" width="48px"
          /></a>
        </li>
      </ul>
    </div>
  </div>
</ng-template>
<ng-template #contact>
  <div class="modal-header py-0 px-1 pt-1 text-right">
    <div class="col-12 text-right py-0 px-0">
      <button
        type="button"
        class="close videoclose"
        data-dismiss="modal"
        aria-label="Close"
        (click)="closeContactModal(f)"
      >
        <div class="float-right mr-1 mt-1">
          <img src="assets/images/editchart-close.svg" width="20" />
        </div>
      </button>
    </div>
  </div>
  <div class="modal-body pt-0">
    <h1 class="text-center conthead font-weight-bold-calibre">
      HOW CAN WE SERVE YOU
    </h1>
    <form
      name="form"
      (ngSubmit)="send($event, f, f.form.valid, 'contactModal')"
      #f="ngForm"
      novalidate
    >
      <div class="service-modal px-5">
        <div class="bdy-sec pt-0">
          <div>
            <p class="sb-ttl font-weight-normal-calibre pb-3">
              Provide your contact details, state your question, and we'll get
              back to you
            </p>
          </div>
          <div class="form-group">
            <input
              type="text"
              class="form-control inputshadow"
              name="fullName"
              [(ngModel)]="userObj.fullName"
              (keydown.space)="
                userObj.fullName ? null : $event.preventDefault()
              "
              #fullName="ngModel"
              [ngClass]="{ 'is-invalid': f.submitted && fullName.invalid }"
              placeholder="FULL NAME"
              required
            />
            <div
              *ngIf="f.submitted && fullName.invalid"
              class="invalid-feedback"
            >
              <div *ngIf="fullName.errors.required" class="boxcolour">
                <span
                  _ngcontent-c2=""
                  class="fa fa-exclamation-circle mr-1"
                  type="Icon"
                ></span
                >Full Name is required
              </div>
            </div>
          </div>
          <div class="form-group">
            <input
              type="text"
              class="form-control inputshadow"
              name="email"
              [(ngModel)]="userObj.emailId"
              (keydown.space)="userObj.emailId ? null : $event.preventDefault()"
              #email="ngModel"
              [ngClass]="{ 'is-invalid': f.submitted && email.invalid }"
              required
              email
              pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)\.*$"
              placeholder="EMAIL ADDRESS"
            />
            <div *ngIf="f.submitted && email.invalid" class="invalid-feedback">
              <div class="boxcolour" *ngIf="email.errors.required">
                <span class="fa fa-exclamation-circle mr-1" type="Icon"></span
                >Email is required
              </div>
            </div>
            <div
              [hidden]="email.valid || email.pristine || !email.errors.pattern"
              class=""
            >
              <div class="boxcolour alertMsg">
                <span class="fa fa-exclamation-circle mr-1" type="Icon"></span
                >Please enter a valid email
              </div>
            </div>
          </div>
          <div class="form-group">
            <textarea
              type="text"
              class="form-control inputshadow removeResize"
              name="contactQues"
              [(ngModel)]="userObj.contactQues"
              (keydown.space)="
                userObj.contactQues ? null : $event.preventDefault()
              "
              #contactQues="ngModel"
              [ngClass]="{ 'is-invalid': f.submitted && contactQues.invalid }"
              placeholder="WHAT'S YOUR BURNING QUESTION?"
              required
            ></textarea>
            <div
              *ngIf="f.submitted && contactQues.invalid"
              class="invalid-feedback"
            >
              <div *ngIf="contactQues.errors.required" class="boxcolour">
                <span
                  _ngcontent-c2=""
                  class="fa fa-exclamation-circle mr-1"
                  type="Icon"
                ></span
                >Please enter a value
              </div>
            </div>
          </div>
          <div class="form-group float-label-control text-center mb-1 pt-2">
            <button
              class="btn mr-2 ml-2 col-12 font-weight-bold-calibre contbtn"
              data-backdrop="false"
            >
              SEND
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>
<ng-template #thank>
  <div class="modal-header pr-1 pt-1 px-0">
    <div class="col-12 text-right">
      <button
        type="button"
        class="close videoclose"
        data-dismiss="modal"
        aria-label="Close"
        (click)="closeResetModal()"
      >
        <div class="float-right mr-1 mt-1">
          <img src="assets/images/editchart-close.svg" width="20" />
        </div>
      </button>
    </div>
  </div>
  <div class="modal-body pt-0">
    <div class="service-modal">
      <div class="bdy-sec">
        <div>
          <p class="sb-ttl resettxt text-center">
            Thank you! Your message has been sent. A member of our team will be
            in touch soon!
          </p>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #ESIID_not_found_from_REP>
  <div class="modal-header py-0 px-1 pt-1">
    <div class="col-12 text-right py-0 px-0">
      <button
        type="button"
        class="close pull-right borderNone closeModelAlign"
        aria-label="Close"
        (click)="modalRef.hide()"
      >
        <div _ngcontent-c5="" class="float-right mr-1 mt-1">
          <img src="assets/images/editchart-close.svg" width="17" />
        </div>
      </button>
    </div>
  </div>
  <div class="modal-body pt-0">
    <h4
      class="utility-modal-title font20 text-center text-uppercase"
      *ngIf="zipcode"
    >
      ESIID NOT FOUND
    </h4>
   
    <p class="utility-sub-title font20">
    Our system is unable to locate your ESIID at this time. When you close out of this message, please manually enter
    your ESIID and proceed to next question.
    </p>
   
    
  </div>
</ng-template>
<!-- <div class="modal fade" data-backdrop="static" data-keyboard="false" id="helpModel" tabindex="-1" role="dialog"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content zind1 brdRadius">
      <div class="modal-body">
        <button type="button" class="close videoclose" data-dismiss="modal" aria-label="Close"
          (click)="closeResetModal()">
          <div class="float-right mr-1 mt-1">
            <img src="assets/images/editchart-close.svg" width="20">
          </div>
        </button>
        <div class="service-modal">
          <div class="bdy-sec">
            <div>
              <p class="mt-4 sb-ttl resettxt text-center">Thank you! Your message has been sent. A member of our team
                will be in touch soon!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->
<!-- Modal -->
<div class="backdrop" [ngStyle]="{ display: display }"></div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{ display: display }">
  <div class="modal-dialog" role="document">
    <div class="modal-content m-auto blockbg boxclr text-center">
      <div class="modal-body">
        <!-- <div class="mt-5"> -->
        <div class="">
          <img src="assets/images/loading.gif" />
          <p class="text-center tipmes font15">
            Please wait for a few seconds...
          </p>
        </div>
        <!-- </div> -->
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</div>
